import { blocksToMarkdown, parseXmlToBlocks } from "@/lib/reportSerializer";
import type { Citation } from "@/types/aiAgent";

const CITATIONS_REGEX = /<citations>([\s\S]*?)<\/citations>/i;

const extractCitations = (reportXml: string, fallback?: Citation[] | null) => {
  if (fallback && fallback.length > 0) {
    return fallback;
  }
  const match = CITATIONS_REGEX.exec(reportXml);
  if (!match) {
    return undefined;
  }
  try {
    const parsed = JSON.parse(match[1]);
    return Array.isArray(parsed) ? parsed : undefined;
  } catch {
    return undefined;
  }
};

export const convertReportXmlToMarkdown = (
  reportXml: string,
  fallbackCitations?: Citation[] | null
) => {
  const citations = extractCitations(reportXml, fallbackCitations);
  const cleanXml = reportXml.replace(CITATIONS_REGEX, "");
  const parsed = parseXmlToBlocks(cleanXml);
  const markdown = blocksToMarkdown(parsed.blocks);
  return {
    title: parsed.title || "Report",
    markdown,
    citations: citations ?? undefined,
  };
};
